import { makeEnvironmentProviders } from '@angular/core';

import { provideAppInsightsCustomAngularPlugin } from '@mp/shared/app-insights/util';

import { AppInsightsFacade, AppInsightsService } from '../services';

export function provideAppInsightsDataAccess() {
  return makeEnvironmentProviders([provideAppInsightsCustomAngularPlugin(), AppInsightsService, AppInsightsFacade]);
}
